module.exports = __webpack_public_path__ + "8bf4b3bd8732f46afbcca539805cc04a.MP3";